import React from "react";
import logo from "../../assets/images/logo.svg"

const Footer = () => {
  return (
    <footer className="bg_footer px-4 lg:px-0 border-t-2 border_dark">
      <div className=" container mx-auto rounded-t-[40px] ">
        <div className="py-7 grid grid-cols-1 lg:grid-cols-2 sm:pb-8">
          <div>
            <div className="flex items-center mb-4">
              <img src={logo} alt="logo" className="w-[70px] h-[60px] " />
            </div>

            <h3 className=" font-semibold my-5 font_family">Contact us:</h3>

            <ul>
              <li className="font_ovo">Email: info@godstanding.com</li>
              <li className="my-5 font_ovo">Phone: 555-567-8901</li>
              <li className="font_ovo">Address: 1234 Main St
              Moonstone City, Stardust State 12345</li>
            </ul>

            <div className="flex space-x-4 w-fit  my-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-linkedin-in text-[20px] bg-black text-white p-[5px] rounded-full"></i>
              </a>

              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-facebook text-[30px]"></i>
              </a>

              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-twitter text-[20px] bg-black text-white  p-[5px] rounded-full"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col w-full lg:w-[85%] ml-auto mt-auto">
            <h3 className=" font-bold my-4 font_family">GOOD NEWS DELIVERED STRAIGHT TO YOUR INBOX</h3>

            <div className="relative bg-[#F6F2EF] border-2 border_dark px-[40px] py-[50px] rounded-xl items-center flex flex-col md:flex-row  justify-between">
              <input
                type="email"
                id="email"
                className="mb-8 md:mb-0 py-[10px] px-4 w-full sm:w-[300px] placeholder-[#FF4161] bg-[#FFEBEF] border border_dark rounded-lg  focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Email"
              />

              <button className="w-full sm:w-fit bg-green-500 text-white py-2 px-8 text-[20px] rounded-lg hover:bg-green-600">
                Subscribe
              </button>
            </div>

          </div>
        </div>

        <div className="border-t border_dark mx-auto container py-8 flex justify-between">
          <p className="font_ovo">
          © 2024 Good Standing. All Rights Reserved.
          </p>

          <p className="font_ovo">
          Terms & Conditions, Privacy Policy
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
